import { render, staticRenderFns } from "./Live70Years.vue?vue&type=template&id=2714f4cb&"
import script from "./Live70Years.vue?vue&type=script&lang=js&"
export * from "./Live70Years.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2714f4cb')) {
      api.createRecord('2714f4cb', component.options)
    } else {
      api.reload('2714f4cb', component.options)
    }
    module.hot.accept("./Live70Years.vue?vue&type=template&id=2714f4cb&", function () {
      api.rerender('2714f4cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/live-70-years/Live70Years.vue"
export default component.exports